import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { CanView } from 'components/Can';
import { Column } from 'primereact/column';
import { DataSource } from 'components/DataSource';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { PageRequestError } from 'components/PageRequestError';
import { Paginator } from 'primereact/paginator';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
const LoanamortListadminPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const utils = useUtils();
	const filterSchema = {
		paydate: {
			tagTitle: "Paydate",
			value: [],
			valueType: 'range-date',
			options: [],
		},
		userid: {
			tagTitle: "Userid",
			value: '',
			valueType: 'single',
			options: [],
		},
		loanaccountno: {
			tagTitle: "Loanaccountno",
			value: '',
			valueType: 'single',
			options: [],
		},
		search: {
			tagTitle: "Search",
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, selectedItems, apiUrl, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, pagination } = pageController;
	const { filters, setFilterValue, setFilterOptions } = filterController;
	const { totalRecords, totalPages, recordsPosition, firstRow, limit, onPageChange } =  pagination;
	function ActionButton(data){
		const items = [
		{
			label: "View",
			command: (event) => { app.navigate(`/loanamort/view/${data.amortid}`) },
			icon: "pi pi-eye",
			visible: () => auth.canView('loanamort/view')
		},
		{
			label: "Edit",
			command: (event) => { app.navigate(`/loanamort/edit/${data.amortid}`) },
			icon: "pi pi-pencil",
			visible: () => auth.canView('loanamort/edit')
		},
		{
			label: "Delete",
			command: (event) => { deleteItem(data.amortid) },
			icon: "pi pi-trash",
			visible: () => auth.canView('loanamort/delete')
		}
	]
	.filter((item) => {
		if(item.visible){
			return item.visible()
		}
		return true;
	});
		return (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items} />);
	}
	function AmortidTemplate(data){
		if(data){
			return (
				<Link to={`/loanamort/view/${data.amortid}`}> { data.amortid }</Link>
			);
		}
	}
	function PaydateTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.paydate )}</>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">Loading...</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					No record found
				</div>
			);
		}
	}
	function MultiDelete() {
		if (selectedItems.length) {
			return (
				<div className="m-2 flex-grow-0">
					<Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title="Delete Selected"/>
				</div>
			)
		}
	}
	function ExportData() {
		if (props.exportData && records.length) {
			const downloadFileName = `${utils.dateNow()}-loanamort`;
			return (
				<div className="m-2">
					<ExportPageData  pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel="" tooltip="Export" buttonIcon="pi pi-print" />
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
		const pagerReportTemplate = {
			layout: pagination.layout,
			CurrentPageReport: (options) => {
				return (
					<>
						<span className="text-sm text-gray-500 px-2">Records <b>{ recordsPosition } of { options.totalRecords }</b></span>
					</>
				);
			}
		}
		return (
			<div className="flex-grow-1">
				<Paginator first={firstRow} rows={limit} totalRecords={totalRecords}  onPageChange={onPageChange} template={pagerReportTemplate} />
			</div>
		)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
	<CanView pagePath="loanamort/delete">
		<MultiDelete />
	</CanView>
				<ExportData />
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="LoanamortListadminPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title="Transaction Schedule"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-fixed " >
                    <CanView pagePath="">
                        <Link to={`/loanamort/add`}>
                            <Button label="Add New Loanamort" icon="pi pi-plus" type="button" className="p-button w-full bg-primary "  />
                            </Link>
                        </CanView>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="p-3 mb-3">
                            <div className="">
                                <Calendar showIcon={true} showButtonBar={true} dateFormat="yy-mm-dd" hourFormat="24" className="w-full" selectionMode="range" value={filters.paydate.value} onChange={(e) => setFilterValue('paydate', e.value)} placeholder="Select date Range"   />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="p-3 mb-3">
                            <DataSource onLoad={(options) => setFilterOptions('userid', options)}  apiPath="components_data/userid_option_list_2"  >
                                {
                                ({ response }) => 
                                <>
                                <Title title="Filter by Vendor"  headerClass="p-3" titleClass="font-bold text-primary" subTitleClass="text-sm text-500"      separator={false} />
                                <div className="">
                                    <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'userid', e.value)} value={filters.userid.value} optionLabel="label" optionValue="value" options={filters.userid.options} placeholder="Select a value ..." >
                                    </Dropdown>
                                </div>
                                </>
                                }
                            </DataSource>
                        </div>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="p-3 mb-3">
                            <DataSource onLoad={(options) => setFilterOptions('loanaccountno', options)}  apiPath="components_data/loanaccountno_option_list_2"  >
                                {
                                ({ response }) => 
                                <>
                                <Title title="Filter by Loanaccountno"  headerClass="p-3" titleClass="font-bold text-primary" subTitleClass="text-sm text-500"      separator={false} />
                                <div className="">
                                    <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'loanaccountno', e.value)} value={filters.loanaccountno.value} optionLabel="label" optionValue="value" options={filters.loanaccountno.options} placeholder="Select a value ..." >
                                    </Dropdown>
                                </div>
                                </>
                                }
                            </DataSource>
                        </div>
                    </div>
                    <div className="col-12 md:col-3 " >
                        <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" />
                        <InputText placeholder="Search" className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                        </span>
                    </div>
                </div>
            </div>
        </section>
        }
        <section className="page-section " >
            <div className="container-fluid">
                <div className="grid ">
                    <div className="col comp-grid" >
                        <FilterTags filterController={filterController} />
                        <div >
                            <PageBreadcrumbs />
                            <div className="page-records">
                                <DataTable 
                                    lazy={true} 
                                    loading={loading} 
                                    selectionMode="checkbox" selection={selectedItems} onSelectionChange={e => setSelectedItems(e.value)}
                                    value={records} 
                                    dataKey="amortid" 
                                    sortField={sortBy} 
                                    sortOrder={sortOrder} 
                                    onSort={onSort}
                                    className=" p-datatable-sm" 
                                    stripedRows={true}
                                    showGridlines={false} 
                                    rowHover={true} 
                                    responsiveLayout="stack" 
                                    emptyMessage={<EmptyRecordMessage />} 
                                    >
                                    {/*PageComponentStart*/}
                                    <Column selectionMode="multiple" headerStyle={{width: '2rem'}}></Column>
                                    <Column  field="amortid" header="Amortid" body={AmortidTemplate}  ></Column>
                                    <Column  field="loanaccountno" header="Loan Account No"   ></Column>
                                    <Column  field="period" header="Period"   ></Column>
                                    <Column  field="paydate" header="Paydate" body={PaydateTemplate}  ></Column>
                                    <Column  field="payment" header="Payment"   ></Column>
                                    <Column  field="current_balance" header="Current Balance"   ></Column>
                                    <Column  field="interest" header="Interest"   ></Column>
                                    <Column  field="principal" header="Principal"   ></Column>
                                    <Column  field="paid" header="Paid"   ></Column>
                                    <Column  field="alerted" header="Alerted"   ></Column>
                                    <Column  field="od_yn" header="Od Yn"   ></Column>
                                    <Column  field="trxnid" header="Trxnid"   ></Column>
                                    <Column  field="merchanttrxnrefid" header="Merchanttrxnrefid"   ></Column>
                                    <Column  field="req_status" header="Req Status"   ></Column>
                                    <Column  field="userid" header="Userid"   ></Column>
                                    <Column  field="payment_transaction_identifier" header="Payment Transaction Identifier"   ></Column>
                                    <Column headerStyle={{width: '2rem'}} headerClass="text-center" body={ActionButton}></Column>
                                    {/*PageComponentEnd*/}
                                </DataTable>
                            </div>
                            <PageFooter />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
	);
}
LoanamortListadminPage.defaultProps = {
	primaryKey: 'amortid',
	pageName: 'loanamort',
	apiPath: 'loanamort/listadmin',
	routeName: 'loanamortlistadmin',
	msgBeforeDelete: "Are you sure you want to delete this record?",
	msgTitle: "Delete record",
	msgAfterDelete: "Record deleted successfully",
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: true,
	importData: false,
	keepRecords: false,
	multiCheckbox: true,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 10,
}
export default LoanamortListadminPage;
